/* Presentaciones de venta (fracciones) — arma las opciones de unidad/precio
   disponibles para un producto a partir de la fila devuelta por
   /api/ventas/productos-busqueda o /api/cotizaciones/productos-busqueda:
   Unidad Mínima, Unidad de Compra (minorista y mayorista) y cualquier
   fracción custom definida en producto_presentaciones. */
export function buildOpciones(row) {
  const factorConv = parseFloat(row.factor_conversion) || 1;
  const ops = [];
  if (parseFloat(row.precio_minimo) > 0) {
    ops.push({ key: 'minima', nombre: row.unidad_short || 'UND', factor: 1, precio: parseFloat(row.precio_minimo) });
  }
  if (parseFloat(row.precio_venta) > 0) {
    ops.push({
      key: 'compra_venta', nombre: row.unidad_compra_short || row.unidad_short || 'UND',
      factor: factorConv, precio: parseFloat(row.precio_venta), label: 'Minorista',
    });
  }
  if (parseFloat(row.precio_mayorista) > 0) {
    ops.push({
      key: 'compra_mayor', nombre: row.unidad_compra_short || row.unidad_short || 'UND',
      factor: factorConv, precio: parseFloat(row.precio_mayorista), label: 'Mayorista',
    });
  }
  (row.presentaciones || []).forEach(p => {
    const factor = parseFloat(p.factor) || 1;
    const precio = (p.precio_venta !== null && p.precio_venta !== undefined && p.precio_venta !== '')
      ? parseFloat(p.precio_venta)
      : (parseFloat(row.precio_minimo) || 0) * factor;
    ops.push({ key: `pres_${p.id}`, nombre: p.nombre, factor, precio, esDefault: !!p.es_default });
  });
  if (ops.length === 0) {
    ops.push({ key: 'minima', nombre: row.unidad_short || 'UND', factor: 1, precio: 0 });
  }
  return ops;
}

export const opcionDefault = (ops) =>
  ops.find(o => o.esDefault) || ops.find(o => o.key === 'compra_venta') || ops[0];

/* Precio de referencia para tarjetas de búsqueda (primer precio configurado) */
export function precioReferencial(row) {
  if (parseFloat(row.precio_venta) > 0)     return { precio: parseFloat(row.precio_venta),     unidad: row.unidad_compra_short || row.unidad_short };
  if (parseFloat(row.precio_minimo) > 0)    return { precio: parseFloat(row.precio_minimo),    unidad: row.unidad_short };
  if (parseFloat(row.precio_mayorista) > 0) return { precio: parseFloat(row.precio_mayorista), unidad: row.unidad_compra_short || row.unidad_short };
  return { precio: 0, unidad: row.unidad_short };
}
